import { Type, type Static } from "@sinclair/typebox";
const nullableId = Type.Union([
  Type.String({ pattern: "^[0-9]{5,30}$" }),
  Type.Null(),
]);
export const WhatsAppSettingsWriteSchema = Type.Object(
  {
    operationId: Type.String({ format: "uuid" }),
    version: Type.Integer({ minimum: 1 }),
    wabaId: nullableId,
    phoneNumberId: nullableId,
    graphVersion: Type.Union([
      Type.String({ pattern: "^v[0-9]{1,3}\\.0$" }),
      Type.Null(),
    ]),
    enabled: Type.Boolean(),
  },
  { additionalProperties: false },
);
export type WhatsAppSettingsWrite = Static<typeof WhatsAppSettingsWriteSchema>;
export const WhatsAppReplySchema = Type.Object(
  {
    operationId: Type.String({ format: "uuid" }),
    text: Type.String({ minLength: 1, maxLength: 4096 }),
  },
  { additionalProperties: false },
);
export type WhatsAppReply = Static<typeof WhatsAppReplySchema>;
export interface WhatsAppSettings {
  version: number;
  wabaId: string | null;
  phoneNumberId: string | null;
  graphVersion: string | null;
  enabled: boolean;
  webhookVerifiedAt: string | null;
  lastWebhookAt: string | null;
}
export interface WhatsAppStatus {
  state: "unconfigured" | "disabled" | "awaiting-webhook" | "ready";
  label: string;
  canSend: boolean;
  lastWebhookAt: string | null;
}
export interface WhatsAppConfiguration {
  settings: WhatsAppSettings;
  status: WhatsAppStatus;
  requirements: { key: string; label: string; present: boolean }[];
  webhookPath: string;
}
export interface WhatsAppConversation {
  id: string;
  waId: string;
  contactName: string | null;
  lastInboundAt: string | null;
  lastMessageAt: string;
  preview: string;
  client: { id: string; name: string } | null;
  clientMatch: "matched" | "ambiguous" | "none" | "restricted";
}
export type WhatsAppMessageStatus =
  | "received"
  | "prepared"
  | "sending"
  | "uncertain"
  | "accepted"
  | "sent"
  | "delivered"
  | "read"
  | "failed";
export interface WhatsAppMessage {
  id: string;
  direction: "inbound" | "outbound";
  kind: string;
  text: string;
  occurredAt: string;
  status: WhatsAppMessageStatus;
  errorCode: string | null;
}
export interface WhatsAppConversationPage {
  items: WhatsAppConversation[];
  hasMore: boolean;
}
export interface WhatsAppThread {
  conversation: WhatsAppConversation;
  messages: WhatsAppMessage[];
  hasMore: boolean;
  replyUntil: string | null;
  canReply: boolean;
  blockedReason: string | null;
}
